'use client';

import s from './IndustryCaseStudy.module.css';
import { useTranslation } from '@/hooks/useTranslation';

/*
 * Customer-story CTA band (Healthcare + Automobile). A brand-blue highlight card
 * linking the industry-specific outcome to the full customer story.
 * Text uses div/span (inherits white from the card) to avoid the legacy
 * h2/p colour overrides — no !important needed.
 *
 * Props: { company, headline, meta, tags: [string], href, eyebrow? }
 */
export default function IndustryCaseStudy({
  company,
  headline,
  meta,
  tags,
  href,
  eyebrow = 'Customer Story'
}) {
  const {
    t
  } = useTranslation();
  if (!company || !href) return null;
  return <section className={s.section} aria-label={t("industrycasestudy.customer_story")}>
      <div className={s.inner}>
        <article className={s.card}>
          <span className={s.decor} aria-hidden="true" />
          <div className={s.body}>
            <span className={s.eyebrow}>{t(eyebrow)}</span>
            <div className={s.company}>{company}</div>
            {headline && <div className={s.headline}>{t(headline)}</div>}
            {meta && <div className={s.meta}>{t(meta)}</div>}
            {tags && tags.length > 0 && <div className={s.tags}>
                {tags.map((tag, i) => <span key={i} className={s.tag}>{t(tag)}</span>)}
              </div>}
          </div>
          <a href={href} className={s.cta}>
            {t('Read the story')}
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
              <path d="M5 12h14M13 5l7 7-7 7" />
            </svg>
          </a>
        </article>
      </div>
    </section>;
}